export default maxLength => ({
    t,
    code,
    description = ''
}) => {
    const tKey = `playtech.mobile.system.gamedescription.${code}`;
    let tValue = t(tKey);

    if (tValue === tKey) {
        tValue = description;
    }

    if (tValue.length > maxLength) {
        tValue = `${tValue.substring(0, maxLength)}...`;
    }

    return {
        description: tValue
    };
};
